import { MESSAGE_CHANNEL } from "../../../../packages/constants";
import { getMessageDataCallback } from "./get-message-data-callback";
import type { ApiMessage, Message } from "../../types";

export const getMessagesData = (
  messages: Array<ApiMessage> = [],
  channel: MESSAGE_CHANNEL
): Array<Message> => messages.reduce(getMessageDataCallback(channel), []);
